module.exports = __webpack_public_path__ + "static/img/200337.49675abd.png";